import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { UserPreferences } from "./types";

export const getUserPreferences = (partnerId: number) =>
    fciFetch<UserPreferences>(
        // TODO: pass `isInstitutional` & do not fetch for institutional
        `/api/search-preferences?partner=${partnerId}&timestamp=${new Date().getTime()}&isInstitutional=false`,
        {
            fci: {
                // Fetches saved user preferences (exactness, filters, etc.)
                // If it fails, the form falls back to defaults
                errorType: FCI_ERROR.Convenience,
                errorInfo: "getUserPreferences",
            },
        },
    );
